import React from 'react';

export const normalizedAssetsFilters = (filter) => {
  const {
    tags = [],
    status = ['Active', 'Standby', 'Not Connected'],
    sort = 'ASC',
    search = '',
    viewFilter = ['Make/Model/Year', 'Driver Name', 'Fuel Level and Fault Codes', 'Location Report'],
    type = ['RZ1', 'AD21', 'AS35', 'AT16'],
    Tag_ids = [],
  } = filter;
  return { tags, status, sort, search, viewFilter, type, Tag_ids };
};

// /////////////////////////////////////////////////////////////////////////////////////////////////
const portalState = {
  portalName: '',
  sidebarSelectedId: '',
  ResponsivesidebarToggle: false,
  AppVerExt: '',
  paginationPageSize: 20,
  assetsFilters: {
    status: ['Active', 'Standby', 'Not Connected'],
    tags: [],
    viewFilter: ['Make/Model/Year', 'Driver Name', 'Fuel Level and Fault Codes', 'Location Report'],
    sort: 'ASC',
    search: '',
    Tag_ids: [],
  },
  tripsView: 'VehicleTrips', // VehicleTrips, viewEvent, viewRecording
  fleetMapPollDb: true,
  tripInfo: null,
  tripEvent: null,
  vehicle: null,
  tripDateRange: null,
  tripRecordingCamFace: 0,
  tripRecordingStart: null,
  tripRecordingThumbnail: '',
  videoPreview: '',
  safetyDateRange: null,
  defaultMapCenter: { lat: 39.82818, lng: -98.5795 },
  maintenanceSchedulingStep: 1,
  installationStep: 0,
  mobileSearchActive: false,
  selfCoachedEvents: [],
  selectedSafetyBehaviors: [],
  showFences: false,
};

export const portalStoreInit = (name) => {
  portalState.portalName = name;
  const portalItem = JSON.parse(localStorage.getItem(`store.${name}.portal`));
  // console.log('portalStoreInit got:', portalItem);
  if (portalItem) {
    portalItem.assetsFilters.status = portalItem.assetsFilters.status.filter((s) => portalState.assetsFilters.status.includes(s));
    if (portalItem.sidebarSelectedId !== undefined) portalState.sidebarSelectedId = portalItem.sidebarSelectedId;
    if (portalItem.paginationPageSize) portalState.paginationPageSize = portalItem.paginationPageSize;
    if (portalItem.assetsFilters) portalState.assetsFilters = portalItem.assetsFilters;
  }
};

// console.log('At global portal store:', portalState);

const portal = (state = portalState, { type, ...rest }) => {
  switch (type) {
    case 'portal/set':
      const newState = { ...state, ...rest };
      localStorage.setItem(`store.${state.portalName}.portal`, JSON.stringify(newState));
      return newState;
    default:
      return state;
  }
};

export default portal;
